import { Vue } from "vue-class-component";
import { Emit } from "vue-property-decorator";

export class DeclineAttentionPopup extends Vue {
    @Emit("closeDecline")
    confirm() {
        this.$emit("confirmDecline");
    }
    @Emit("close")
    closePopup() {
        this.$emit("close");
    }
}
